import * as React from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FavoriteIcon from '@mui/icons-material/Favorite';
import NavigationIcon from '@mui/icons-material/Navigation';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import Card from '@mui/material/Card';
import { useHistory, Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import SearchIcon from '@mui/icons-material/Search';

export default function TopActions(props) {
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };
  return (
    <Card
      sx={{
        p: 2,
        mb: 2,
        flexGrow: 1,
        '& > *': {
          m: 1,
        },
      }}
    >
      <ButtonGroup variant="text" aria-label="text button group">
        <Button sx={{ mr: 2 }} onClick={goBack}>
          <ArrowBackIcon />
        </Button>
        {props.newHref && <Link to={props.newHref} params={{ testvalue: "hello" }} className={props.newVisible}>
          <Button>
            <AddIcon />
          </Button>
        </Link>}
        {props.addNew && <a
          href={props.addNew}
          onClick={props.addNew}
        >
          <Button>
            <AddIcon />
          </Button>
        </a>}
        
        <a
          href={props.saveHref}
          onClick={props.save}
          className={props.saveVisible}
        >
          <Button>
            <SaveIcon />
          </Button>
        </a>

        {props.addAllWorkers && <a
          href={props.addAllWorkers}
          onClick={props.addAllWorkers}
        >
          <Button>
            <AddIcon /> Add all workers
          </Button>
        </a>}

        {props.downloadContract && <a
          href={props.downloadContract}
          onClick={props.downloadContract}
        >
          <Button>
            <DownloadIcon /> 
          </Button>
        </a>}

        {props.uploadContract && <a
          href={props.uploadContract}
          onClick={props.uploadContract}
        >
          <Button>
            <UploadIcon /> 
          </Button>
        </a>}

        {props.exportToCsv && <a
          href={props.exportToCsv}
          onClick={props.exportToCsv}
        >
          <Button>
            To csv 
          </Button>
        </a>}


        {props.monthYearSelect && <select 
          className='top-action-select'
          value={props.month}
          onChange={(e) => props.setSearchQuery(e, 'month')}  
        >   
          {
            props?.months?.map(m =>{
              return <option value={m.no}>{m.name}</option>
            })
          }
        </select>}

        {props.monthYearSelect && <input type="number" className='top-action-select'
          value={props.year}
          onChange={(e) => props.setSearchQuery(e, 'year')}></input>}

        {props.monthYearSelect && <Button onClick={() => props.search()}><SearchIcon /></Button>}

        {/* <Button>Three</Button> */}
      </ButtonGroup>
      {/* <Link to={props.newHref}>
        <Fab size="small" color="primary" aria-label="add">
          <AddIcon />
        </Fab>
      </Link>
      <a href={props.saveHref} onClick={props.save}>
        <Fab size="small" color="info" aria-label="save">
          <SaveIcon />
        </Fab>
      </a> */}
    </Card>
  );
}
